// Shrimp quantity deal bar: the script for snippets/mm-shrimp-bar.liquid (markup, look and history live there).
// Oct 30 2026 (David, 1:52 p.m.: the threshold bar "doesn't work on the desktop product pop up"): moved out of the snippet because Horizon's
// quick add morphs the product into #quick-add-modal-content and inline scripts there never run. Loaded on every page from
// snippets/mm-shrimp-free.liquid; each bar (product page or quick-add pop-up) works inside its own product box, not `main .product-details`.
import { StandardEvents } from '@shopify/events';

const bars = new Set();
let inCart = 0;
const money = c => '$' + (c / 100).toFixed(2);

function setup(bar) {
  bar.__mm = true;
  const tiers = bar.dataset.tiers.split(',').map(t => { const [q, p] = t.split(':').map(Number); return { q, p }; });
  const freeAt = +bar.dataset.freeAt || 5, last = tiers[tiers.length - 1].q;
  let V = {}; try { V = JSON.parse(bar.dataset.v); } catch (e) {}
  const stk = bar.querySelector('.mm-tierbar__stock'), msg = bar.querySelector('.mm-tierbar__msg'), fill = bar.querySelector('.mm-tierbar__fill');
  // the product box this bar belongs to: the pop-up's content, or the product page's details column
  const root = () => bar.closest('#quick-add-modal-content') || bar.closest('.product-details') || document;
  const form = () => root().querySelector('form[data-type="add-to-cart-form"]');
  const qtyNow = () => { const i = form() && form().querySelector('input[name="quantity"]'); return Math.max(1, parseInt(i && i.value, 10) || 1); };
  const vidNow = () => { const i = form() && form().querySelector('input[name="id"], select[name="id"]'); return (i && i.value) || bar.dataset.first; };
  const maxFor = s => (window.mmShrimpMax || ((l, f) => (l > f ? l - 1 : Math.min(l, f - 1))))(s, freeAt);
  // The most one order can take: stock less the free +1 (David, Oct 24 2026, 2:33 a.m.). Horizon's quantity box already subtracts what's in
  // the cart (data-cart-quantity), so max = maxFor(stock).
  function capInput(v) {
    const i = form() && form().querySelector('input[name="quantity"]'); if (!i || v.s == null) return;
    const m = String(Math.max(1, maxFor(v.s)));
    if (i.max !== m) i.max = m;
    const cq = parseInt(i.getAttribute('data-cart-quantity'), 10) || 0, room = Math.max(1, +m - cq);
    if ((parseInt(i.value, 10) || 1) > room) { i.value = room; i.dispatchEvent(new Event('change', { bubbles: true })); }
  }
  let painting = false;
  function draw() {
    if (!bar.isConnected) return;
    painting = true;
    const v = V[vidNow()] || {}; capInput(v);
    if (stk.parentElement !== bar) bar.prepend(stk);
    stk.hidden = v.s == null;
    const st = v.s != null ? maxFor(v.s) + ' in stock' : '';   // the most one order can take (stock less the free +1; David, Oct 27 2026)
    if (v.s != null && stk.textContent !== st) stk.textContent = st;
    const q = qtyNow(), n = q + inCart, price = v.p || 0;
    let cur = null;
    tiers.forEach(t => { if (n >= t.q) cur = t; });
    const next = tiers.find(t => n < t.q) || null;
    const w = Math.min(100, n / last * 100) + '%';
    if (fill.style.width !== w) fill.style.width = w;
    bar.querySelectorAll('.mm-tierbar__tick').forEach(k => k.classList.toggle('is-on', n >= +k.dataset.q));
    const free = q >= freeAt, freeOk = free && (v.s == null || v.s >= q + 1), most = v.s == null ? null : maxFor(v.s);
    const parts = [];
    if (cur) parts.push(`<b>${cur.p}% off</b> ${money(Math.round(price * (100 - cur.p) / 100))} each`);
    if (free) parts.push(freeOk ? '<b>+1 free</b> DOA insurance shrimp added in the cart' : `${most} is the most we can send in one order`);
    if (next) parts.push(`add ${next.q - n} more for ${next.p}% off${!free && next.q === freeAt ? ' + 1 free shrimp' : ''}${most != null && most < next.q - inCart ? ' (mix in another grade or shrimp)' : ''}`);
    else parts.push('best price reached');
    if (inCart && cur) parts.push(`(counting ${inCart} already in your cart)`);
    const html = parts.join(' · ').replace(/^add/, 'Add');
    if (msg.innerHTML !== html) msg.innerHTML = html;
    showTotal(q, cur ? Math.round(price * (100 - cur.p) / 100) : price, cur, price);   // total = Shopify's own math (whole line x %), so cents match the cart
    painting = false;
  }
  // Oct 24 2026, 2:29 a.m. (David): the big price is quantity x the price each after the current break; a small line under it says how.
  // Quantity 1 with no break shows the shelf price. Horizon redraws the price on a variant change, so it's re-applied.
  function showTotal(q, each, cur, shelf) {
    if (!Object.keys(V).length) return;
    root().querySelectorAll('product-price [ref="priceContainer"]').forEach(box => {
      const b = box.querySelector('.price bdi, .price-item__group.price bdi'); if (!b) return;
      if (b.dataset.mmShelf == null) b.dataset.mmShelf = b.textContent;
      const on = q > 1 || !!cur, txt = on ? money(Math.round(q * shelf * (100 - (cur ? cur.p : 0)) / 100)) : b.dataset.mmShelf;
      if (b.textContent !== txt) b.textContent = txt;
      box.querySelectorAll('.compare-at-price').forEach(c => { if (c.hidden !== on) c.hidden = on; });
      let nt = box.querySelector('.mm-tot-note');
      if (on) {
        if (!nt) { nt = document.createElement('span'); nt.className = 'mm-tot-note'; b.closest('.price, .price-item__group')?.after(nt); }
        const t = q + ' × ' + money(each) + ' each' + (cur ? ' (' + cur.p + '% off)' : '');
        if (nt.textContent !== t) nt.textContent = t;
      } else if (nt) nt.remove();
    });
  }
  const c = { bar, root, draw, busy: () => painting };
  bars.add(c);
  draw();
}

function live() { bars.forEach(c => { if (!c.bar.isConnected) bars.delete(c); }); return [...bars]; }
function scan() { document.querySelectorAll('.mm-tierbar').forEach(b => { if (!b.__mm) setup(b); }); }
const later = (fn, ms) => setTimeout(fn, ms || 0);

async function readCart() {
  try {
    const cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
    inCart = (cart.items || []).filter(it => it.product_type === 'Live Aquarium Shrimp' && /moss\s*&\s*molt/i.test(it.vendor || '') && it.price > 0)
      .reduce((t, it) => t + it.quantity, 0);
  } catch (e) {}
  live().forEach(c => c.draw());
}

// user input inside a bar's product box redraws that bar
['input', 'change', 'click', 'keyup'].forEach(t => document.addEventListener(t, e => {
  const el = e.target; if (!(el instanceof Element)) return;
  live().forEach(c => { const r = c.root(); if (r !== document && r.contains(el)) later(c.draw); });
}, true));
document.addEventListener('variant:update', () => live().forEach(c => { later(c.draw); later(c.draw, 120); later(c.draw, 400); }));
document.addEventListener(StandardEvents.cartLinesUpdate, e => { (e.promise || Promise.resolve()).then(() => later(readCart, 200)); });
matchMedia('(max-width: 749px)').addEventListener('change', () => live().forEach(c => later(c.draw)));
// new bars (the pop-up fills in after a click) and Horizon redrawing the price or morphing the pop-up: find and redraw
let q = 0;
const hit = new Set();
new MutationObserver(recs => {
  for (const r of recs) {
    const t = r.target instanceof Element ? r.target : r.target.parentElement; if (!t) continue;
    live().forEach(c => { const rt = c.root(); if (!c.busy() && rt !== document && rt.contains(t) && !c.bar.contains(t)) hit.add(c); });
  }
  if (q) return; q = requestAnimationFrame(() => { q = 0; scan(); const h = [...hit]; hit.clear(); h.forEach(c => c.draw()); });
}).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
scan(); readCart();
